import o from "./floatWindowContent.vue2.js";
import "./floatWindowContent.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const e = /* @__PURE__ */ t(o, [["__scopeId", "data-v-66c30ecd"]]);
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/float-window/floatWindowContent.vue.js
// module id = 1247
// module chunks = 41